// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__3PZBB","spin":"Loading_spin__12GWD"};